import React from "react";
import AdminHeader from "../../../../components/admin/AdminHeader";
import { AdminFooter } from "../../../../components/admin/AdminFooter";
import AdminTestimonialUpdate from "../../../../views/admin/cms/testimonials/AdminTestimonialUpdate";

const AdminTestimonialUpdatePage = () => {
  window.scrollTo(0, 0);

  return (
    <div>
      <AdminHeader />
        <AdminTestimonialUpdate />
      <AdminFooter />
    </div>
  );
};

export default AdminTestimonialUpdatePage;
